module.exports = __webpack_public_path__ + "img/long-neck-1.91a29b4c.webp";